import React from 'react'
import { Button, Avatar, Typography, Tooltip } from 'antd'
import { resourceParams } from '../constants'
import ResourceInfo from './ResourceInfo'
import PotentialPayment from '../../PotentialPayment'

const ResourceCard = ({
  src = null,
  isAssigned,
  payment,
  confirmPayment,
  name,
  phone,
  resourceId,
  disabledButton,
  callback,
  locale,
  showButton,
  tooltipText = '',
  onClickResource = () => {}
}) => {
  const { name: btnName, action, disabled = false } = callback
  return (
    <div {...resourceParams.container}>
      <div className='avatar-container'>
        <Avatar {...resourceParams.avatar} src={isAssigned ? src : ''} />
      </div>
      <Typography.Text>
        {isAssigned ? ResourceInfo({ name, phone, resourceId, locale, onClickResource }) : locale.unassigned}
      </Typography.Text>
      <div className='resource-extra-info'>
        {payment && (
          <PotentialPayment
            payment={payment}
            confirmPayment={confirmPayment}
            potentialPaymentClass='resource-card-potential-payment'
          />
        )}
        {showButton && (
          <Tooltip placement='top' title={tooltipText}>
            <Button
              type={isAssigned ? '' : 'primary'}
              {...resourceParams.button}
              onClick={action}
              disabled={disabledButton || disabled}
            >
              {btnName}
            </Button>
          </Tooltip>
        )}
      </div>
    </div>
  )
}

export default ResourceCard
